import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';

import { ImprimirMultipleService } from 'src/app/services/imprimirMultiples/imprimirMultipleService';
import { ImprimirMultipleControlComponent } from './imprimir-control.component';
import { ImprimirControlSharedModule } from '../../imprimir/imprimir-control/imprimirControl.module.share';



@NgModule({
    declarations: [
        ImprimirMultipleControlComponent
    ],
    imports: [ 
        CommonModule,
        ButtonModule,
        ImprimirControlSharedModule 
    ],
    exports: [ 
        ImprimirMultipleControlComponent
     ],
    providers: [ImprimirMultipleService],
})
export class ImprimirControlMultipleSharedModule {}